import { CoreIcon } from '../core-icon';
import carFillSVG from '../../assets/icons/car-fill.svg';
import type { IconProps } from '../core-icon';

export const CarFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={carFillSVG} {...props} />;
};
